export const Create_Default_User_Api = `${process.env.REACT_APP_AUTH_API}/v1`
export const Create_User_X_API_KEY = process.env.REACT_APP_AUTH_API_KEY

export const USER_X_API_KEY =process.env.REACT_APP_CREATE_USER_API_KEY
export const Console_User_Api =`${process.env.REACT_APP_CREATE_USER_API}/console/v1`;

export const Create_FeatureConfig_Api = process.env.REACT_APP_CONSOLE_API
export const ConsoleAPI = `${process.env.REACT_APP_CONSOLE_API}/console/v1`
export const X_API_KEY = process.env.REACT_APP_CONSOLE_API_KEY
